import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

/** Component that has no functionality other than plain html text in the template */
@Component({
    selector: 'app-home-page',
    templateUrl: './home-page.component.html',
    styleUrls: ['./home-page.component.scss'],
    standalone: false
})
export class HomePageComponent implements OnInit {

	/** empty constructor */
	constructor() {

	}

	/** used for functionality that doesn't belong in the constructor but still
	 * needs to be run at the beginning of the lifecycle of the component.
	 */
	ngOnInit() {
	}

}
